import { type MenuItemType } from "@/types";

export const menuItems: MenuItemType[] = [
  {
    icon: "dashboard",
    slug: "overview",
    label: "",
    isTitle: true,
    children: [
      {
        url: "/",
        slug: "pages:Overview",
        label: "Overview",
        icon: "dashboard",
      },
    ],
  },
  {
    slug: "work",
    label: "Work",
    isTitle: true,
    children: [
      {
        url: "/invitation",
        slug: "pages:Invitations",
        label: "Invitations",
        icon: "mail",
      },
      {
        url: "/engagements",
        slug: "pages:engagements",
        label: "My engagements",
        icon: "streamline-sharp:slide-show-play",
      },
    ],
  },
  {
    slug: "learning",
    label: "Learning",
    isTitle: true,
    children: [
      {
        url: "/events-cme",
        slug: "pages:events-cme",
        label: "Events & CME",
        icon: "bi:play-btn",
      },
    ],
  },
  {
    slug: "account",
    label: "Account",
    isTitle: true,
    children: [
      {
        url: "/profile",
        slug: "pages:profile-privacy",
        label: "Profile & privacy",
        icon: "settings",
      },
    ],
  },
];
